// src/utils/common.js
import Decimal from 'decimal.js'
/**
 * 公共方法集合
 */
 //是否显示会员价格
 export function isShowVipPrice(floor,clear,discount) {
    if(localStorage.getItem('shopH5User')){
        if(Number(floor) > 0 && clear==2 && Number(discount)>0){
            return true
        }else{
            return false
        }
    }else{
        return false
    }
    
  }
  // 会员价格
  export function getVipPrice(value,discount) {
    var price=((Number(value)*Number(discount))/10).toFixed(2)
    return price
  }

  export function subtract(a, b) {
    // 容错处理：空值/undefined 按 0 计算
    const numA = new Decimal(a || 0)
    const numB = new Decimal(b || 0)
    return numA.sub(numB).toFixed(2) // 保留2位小数
  }

  export function videoPic(video) {
    return video + '?vframe/jpg/offset/1' // 视频封面
  }
  